import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { getFile } from '../../../../util/file.js';
import { getContentBlockItemValue, getContentBlockItemsByName, getContentBlockMixedItem } from '../../../Cms/CmsActions.js';

import HtmlComponent from '../../../../components/Text/HtmlComponent.js';

// "Notre salaison" trust module rendered at the bottom of category pages (see CategoryViewPage).
// Answers Google's E-E-A-T "Who": names the producer, its history and family roots. Content is
// fully CMS-driven (one `producer` panel per language) so nothing here is hard-coded copy.
function PanelProducer({ panel }) {
    const eyebrow = getContentBlockItemValue(panel.blocks, 'eyebrow');
    const title = getContentBlockItemValue(panel.blocks, 'title');
    const text = getContentBlockItemValue(panel.blocks, 'text');
    const imagePath = getContentBlockItemValue(panel.blocks, 'image', 'path');
    const imageAlt = getContentBlockItemValue(panel.blocks, 'image', 'text') || title;
    const linkLabel = getContentBlockItemValue(panel.blocks, 'linkLabel');
    const linkUrl = getContentBlockItemValue(panel.blocks, 'linkUrl');

    const highlights = getContentBlockItemsByName(panel.blocks, 'highlights')
        .map(item => ({
            value: (getContentBlockMixedItem(item, 'value') || {}).text,
            label: (getContentBlockMixedItem(item, 'label') || {}).text,
        }))
        .filter(highlight => highlight.value || highlight.label);

    if(!title && !text) {
        return null;
    }

    return (
        <section className="bg-white border-top">
            <Container className="px-2 px-md-0 py-4 py-md-5">
                <Row className="align-items-center g-4 g-lg-5">
                    {imagePath && (
                        <Col xs="12" md="5" lg="6">
                            <picture>
                                <source srcSet={getFile(imagePath, { format: 'webp', width: 800 })} type="image/webp" />
                                <img
                                    src={getFile(imagePath, { width: 800 })}
                                    alt={imageAlt}
                                    className="w-100 rounded-3 shadow-sm"
                                    style={{ objectFit: 'cover', aspectRatio: '4 / 3' }}
                                    loading="lazy"
                                />
                            </picture>
                        </Col>
                    )}

                    <Col xs="12" md={imagePath ? 7 : 12} lg={imagePath ? 6 : 12}>
                        {eyebrow && (
                            <span className="d-inline-block mb-2 text-uppercase fw-bold text-danger small" style={{ letterSpacing: '0.1em' }}>
                                {eyebrow}
                            </span>
                        )}
                        {title && <h2 className="h3 fw-bold text-dark mb-3">{title}</h2>}
                        {text && <div className="text-body lh-base"><HtmlComponent text={text} /></div>}

                        {highlights.length > 0 && (
                            <div className="d-flex justify-content-between mt-2">
                                {highlights.map(highlight => (
                                    <div key={`${highlight.value || ''}-${highlight.label || ''}`}>
                                        {highlight.value && <div className="h4 fw-bold text-danger mb-0">{highlight.value}</div>}
                                        {highlight.label && <div className="small text-muted">{highlight.label}</div>}
                                    </div>
                                ))}
                            </div>
                        )}

                        {linkLabel && linkUrl && (
                            <Button as={Link} to={linkUrl} variant="outline-dark" className="mt-4">
                                {linkLabel}
                            </Button>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

PanelProducer.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelProducer;
